module.exports = __webpack_public_path__ + "static/media/lt.7e7110b6.svg";